/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.DynamicScriptLoaderStartup = function () {
    if (OCS && !OCS.Functions.hasOwnProperty('DynamicScriptLoader')) {
        // OCS.Functions.DynamicScriptLoader contains all the publically accessible calls
        OCS.DynamicScriptLoader = new OCS.Classes.DynamicScriptLoader();
    }
};